<div #lineColorChart></div>
